import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://helping-hands-wild-breeze-4103.fly.dev/api/v1";

const api = axios.create({
  baseURL: API_BASE_URL,
});

export default api;
